@if (lines.length || isRental) {
  <div class="pagecontent fixedtop">
    @if (parentOrderId) {
      <div class="parent-order-banner">
        <mat-icon class="banner-icon">subdirectory_arrow_right</mat-icon>
        <span>{{ parentLabel[0] }} </span>
        <a class="parent-link" [routerLink]="['/sales/quotation', parentOrderId]">
          {{ parentLabel[1] }} N°{{ parentOrderId }}
        </a>
      </div>
    }
    <div class="order-header">
      <a class="deliveries-title" [routerLink]="['/sales/quotation', quotationId]">
        {{ isRental ? 'Dossier de location' : 'Commande' }} N°{{ quotationId }}
      </a>
      @if (docRef) {
        <span class="docref-chip"
          [class.chip-ticket]="docRef.startsWith('TK-')"
          [class.chip-facture]="docRef.startsWith('FAC-')"
          [class.chip-avoir]="docRef.startsWith('AV-')"
          matTooltip="Référence officielle de pièce scellée (BOFIP ISCA)">{{ docRef }}</span>
      }
      @if (stationLabel) {
        <span class="station-chip"
        matTooltip="Poste de travail et établissement où cette commande a été saisie">{{ stationLabel }}</span>
      }
    </div>

    <!-- Cycle d'un dossier de location : l'état du contrat reste « Validé », c'est ici qu'on lit livraison et facturation. -->
    @if (isRental) {
      <section class="rental-cycle">
        @if (lifecycleLoading) {
          <div class="rc-loading">
            <mat-progress-spinner mode="indeterminate" diameter="18" strokeWidth="3"></mat-progress-spinner>
            <span>Lecture du cycle de location…</span>
          </div>
        } @else if (lifecycleError) {
          <div class="rc-error">{{ lifecycleError }}</div>
        } @else if (lifecycle) {
          @if (reprise) {
            <div class="rc-reprise" matTooltip="Dossier en cours repris d'orthop : « facturé jusqu'au » vient d'orthop tant que Mercalink n'a rien facturé">{{ reprise }}</div>
          }
          <div class="rc-delivery" [class.rc-ko]="!lifecycle.realdatdel"
            matTooltip="La facturation part de la première livraison du dossier ; sans bon de livraison livré, le moteur ne facture rien">
            @if (lifecycle.realdatdel) {
              Livré le {{ blDay(lifecycle.realdatdel) }}
            } @else if (lifecycle.reprise?.livre_a_la_reprise === false) {
              Repris sans bon de livraison : la facturation attend une livraison
            } @else {
              Non livré{{ lifecycle.planned_delivery_on ? ' · livraison prévue le ' + day(lifecycle.planned_delivery_on) : '' }}
            }
          </div>

          @for (l of rentalLines; track l.id) {
            <div class="rc-line">
              <div class="rc-line-head">
                <span class="rc-name">{{ title(l) }}</span>
                <span [class]="'rc-pill rc-' + l.status" [matTooltip]="statusHint(l)">{{ statusLabel(l) }}</span>
              </div>
              @if (article(l); as a) { <div class="rc-article">{{ a }}</div> }
              <dl class="rc-facts">
                @if (l.typ === 'RENTAL') {
                  <dt>Livré</dt>
                  <dd>{{ l.realdatdel ? blDay(l.realdatdel) : '—' }}</dd>
                  <dt>Facturé jusqu'au</dt>
                  <dd [matTooltip]="billedUntilHint(l)">
                    {{ l.billed_until ? day(l.billed_until) : 'jamais facturé' }}
                    @if (l.billed_until_source === 'orthop') { <span class="rc-src">orthop</span> }
                  </dd>
                  <dt>Période</dt>
                  <dd matTooltip="Rang de la dernière période facturée (dégressivité, reprise orthop comprise) / Durée prévue">{{ progress(l) }} · {{ periodName(l.period) }}</dd>
                  @if (l.due_count > 0) {
                    <dt>Échu</dt>
                    <dd class="rc-due">{{ l.due_count }} période{{ l.due_count > 1 ? 's' : '' }} {{ span(l.due_start, l.due_end) }}</dd>
                  }
                  @if (l.summary?.next_due_on) {
                    <dt>Prochaine</dt>
                    <dd>facturable le {{ day(l.summary?.next_due_on) }}</dd>
                  }
                  @if (l.lifecycle_unreadable) {
                    <dt>Attention</dt>
                    <dd class="rc-due">cycle de la ligne illisible : ligne bloquée, rien n'est facturé</dd>
                  }
                } @else {
                  <dt>Récupération</dt>
                  <dd>{{ l.realdatdel ? 'bon de livraison livré le ' + blDay(l.realdatdel) : 'non effectuée' }}</dd>
                }
              </dl>
            </div>
          } @empty {
            <div class="rc-empty">Aucune ligne de location sur ce dossier.</div>
          }

          <div class="rc-subtitle">Factures émises ({{ lifecycle.invoices.length }})</div>
          @if (lifecycle.invoices.length) {
            <table class="delivery-table rc-invoices">
              <thead>
                <tr>
                  <th class="col-ref">Facture</th>
                  <th>Période facturée</th>
                  <th class="col-amount">TTC</th>
                  <th class="col-state">État</th>
                </tr>
              </thead>
              <tbody>
                @for (f of lifecycle.invoices; track f.id) {
                  @if (isFseInvoice(f)) {
                    <tr>
                      <td class="col-ref">{{ f.doc_ref ?? ('N°' + f.id) }}</td>
                      <td>{{ span(f.start, f.end) }}</td>
                      <td class="col-amount">{{ f.amount_taxi | number:'1.2-2' }}</td>
                      <td class="col-state">{{ invoiceStateLabel(f.state) }}</td>
                    </tr>
                  } @else {
                    <tr class="clickable-row">
                      <a [routerLink]="['/sales/quotation', f.id]" style="display: contents">
                        <td class="col-ref">{{ f.doc_ref ?? ('N°' + f.id) }}</td>
                        <td>{{ span(f.start, f.end) }}</td>
                        <td class="col-amount">{{ f.amount_taxi | number:'1.2-2' }}</td>
                        <td class="col-state">{{ invoiceStateLabel(f.state) }}</td>
                      </a>
                    </tr>
                  }
                }
              </tbody>
            </table>
          } @else {
            <div class="rc-empty">Aucune facture fille émise par Mercalink.</div>
          }
        }
      </section>
    }

    @if (lines.length) {
    <table class="delivery-table">
      <thead>
        <tr>
          <a [routerLink]="['/sales/quotation', quotationId]" style="display: contents">
            <th class="col-name">Produit</th>
            <th class="col-qty">Qté</th>
            <th class="col-uprice" title="Prix TTC d'un conditionnement, avant remise">Px. cond.</th>
          </a>
        </tr>
      </thead>
      <tbody>
        @for (p of lines; track p.id) {
          <tr class="clickable-row">
            <a [routerLink]="['/sales/product', p.product]" style="display: contents">
              <td class="col-name">{{ p.product_name }}</td>
              <td class="col-qty">{{ p.qty }}</td>
              <td class="col-uprice">{{ p.uprice_taxi }}</td>
            </a>
          </tr>
        }
      </tbody>
    </table>
    <div class="deliveries-section">
      <a class="deliveries-title" [routerLink]="['/logistic/delivery', quotationId]">
        Livraison{{ deliveries.length > 1 ? 's' : '' }}
      </a>
      @for (delivery of deliveries; track delivery.id; let i = $index) {
        <div class="delivery-block">
          <a class="delivery-link" [routerLink]="['/logistic/delivery', quotationId]" [queryParams]="{index: i}">
            <div class="delivery-header">
              <span class="delivery-mode">{{ getDeliveryModeLabel(delivery.mode) }}</span>
              @if (delivery.askdatdel) {
                <span class="delivery-date">{{ delivery.askdatdel | date:'dd/MM/yyyy' }}</span>
              }
              @if (delivery.askslot) {
                <span class="delivery-slot">{{ getSlotLabel(delivery.askslot) }}</span>
              }
            </div>
          </a>
          <table class="delivery-table">
            <thead>
              <tr>
                <th class="col-name">Produit</th>
                <th class="col-qty">Qté</th>
                <th class="col-uprice" title="Prix TTC d'un conditionnement, avant remise">Px. cond.</th>
              </tr>
            </thead>
            <tbody>
              @for (line of getDeliveryLines(delivery); track line.id) {
                <tr class="clickable-row">
                  <a [routerLink]="['/sales/product', line.product]" [queryParams]="{index: i}"
                    style="display: contents">
                    <td class="col-name">{{ line.product_name }}</td>
                    <td class="col-qty">{{ line.qty }}</td>
                    <td class="col-uprice">{{ line.uprice_taxi }}</td>
                  </a>
                </tr>
              }
            </tbody>
          </table>
        </div>
      }
    </div>
    }
  </div>
}
